import { Theme } from '@mui/material/styles'
export const getStyles = (theme: Theme) => ({
  expandLink: {
    color: '#1565c0',
    cursor: 'pointer',
    fontSize: '13px',
    fontWeight: '500',
  },

  variantLabel: {
    fontFamily: 'Source Sans Pro Semibold',
  },

  item: {
    width: '100%',
  },

  card: {
    padding: `0 0 0 ${theme.spacing(1.2)}`,
  },
})
